var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"decimal-number"},[_vm._v(_vm._s(_vm.int)),_c('span',{class:_vm.decimalSize},[_vm._v(_vm._s(_vm.decimal))])])
}
var staticRenderFns = []

export { render, staticRenderFns }